import type { AssignmentVersion, Feedback, Submission } from "@/lib/api/assignments";
import { AttemptContent } from "@/components/assignments/coursework/AttemptContent";
import { FeedbackThread } from "@/components/assignments/FeedbackThread";

/** The native resolver supplies one exact authorized attempt and event. */
export function GradeContributionEvidence({ attempt, version, feedback }: {
  attempt: Submission;
  version: AssignmentVersion;
  feedback: Feedback;
}) {
  return <div className="grid gap-5" data-contribution-attempt={attempt.id} data-contribution-feedback={feedback.id}>
    <section aria-label="Original assignment terms" className="grid gap-2">
      <p dir="auto" className="whitespace-pre-wrap">{version.instructions}</p>
      {version.points !== null && <p className="text-meta text-muted-foreground">Original maximum: {Number(version.points)} points</p>}
    </section>
    <section aria-label={attempt.attempt_number === null ? "Instructor record" : `Attempt ${attempt.attempt_number}`} className="grid gap-2">
      <AttemptContent attempt={attempt} expanded />
    </section>
    <section aria-label="Released feedback">
      <FeedbackThread events={[feedback]} emptyLabel="" scale={version.scale} />
    </section>
  </div>;
}
